import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';
import { Roleindicator  } from './roleindicatorTypes';

export const createRoleIndicator = createAsyncThunk(
    'performance/createRoleIndicator',
    async (data: Roleindicator, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.post('/performance/roleindicator', data);          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create Role-indicator');
      }
    }
  );

  export const fetchAllRoleindicator = createAsyncThunk(
    'performance/fetchAllRoleindicator',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/performance/roleindicator');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Role-indicator');
        }
    }
);



export const fetchRoleindicatorById = createAsyncThunk(
    'performance/fetchRoleIndicatorById',
    async (Roleindicator: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/performance/roleindicator/${Roleindicator}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Role-indicator');
        }
    }
);

export const deleteRoleindicator = createAsyncThunk(
    'performance/deleterating',
    async (Roleindicator: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/performance/roleindicator/${Roleindicator}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete Role-indicator');
        }
    }
);

export const updateRoleindicator = createAsyncThunk<any , {Roleindicator: number; data: any}, { rejectValue: string }>(
    'performance/updateRoleindicator',
    async ({Roleindicator , data}: {Roleindicator : Number; data: Partial<any>}, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.put(`/performance/roleindicator/${Roleindicator}`, data)
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create Role-indicator');
      }
    }
  ); 